(() => {
  const clickableElements = document.querySelectorAll<HTMLElement>('.js-clickable-element');

  if (clickableElements) {
    clickableElements.forEach((element: HTMLElement) => {
      const url = element.dataset.url;
      const target = element.dataset.target === '' ? '_self' : element.dataset.target ?? '_self';

      if (url) {
        element.addEventListener('click', (e) => openUrlInNewTarget(e, url, target));
        element.addEventListener('keydown', (e) => {
          e.key === 'Enter' && openUrlInNewTarget(e, url, target);
        });
      }
    });
  }

  const openUrlInNewTarget = (event: Event, url: string, target: string) => {
    event.preventDefault();
    event.stopPropagation();

    window.open(url, target);
  };
})();
